import React, { useCallback, useEffect, useState, memo } from 'react';
import { IconButton, Box } from '@chakra-ui/react';
import { ArrowUp } from 'lucide-react';
export const BackToTop = memo(function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;
      if (currentScrollY < lastScrollY && currentScrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  return <Box position="fixed" bottom={8} right={8} zIndex={1000} opacity={isVisible ? 1 : 0} transform={isVisible ? 'translateY(0)' : 'translateY(20px)'} transition="all 0.3s" pointerEvents={isVisible ? 'auto' : 'none'} data-id="element-22">
      <IconButton aria-label="Back to top of page" icon={<ArrowUp aria-hidden="true" data-id="element-24" />} onClick={scrollToTop} bgGradient="linear(to-r, #2c0842, #1E73BE)" color="white" size="lg" borderRadius="full" shadow="lg" _hover={{
      transform: 'scale(1.1)',
      bgGradient: 'linear(to-r, #1E73BE, #2c0842)'
    }} transition="transform 0.2s" data-id="element-23" />
    </Box>;
});